import moment from "moment-timezone";
import PrivateSerieModel from "src/models/PrivateSerieModel";
import { dateFormatMed } from "src/utils/constants";
import { Frequency } from "types/code-generator";
import { ClassTimes } from "./ClassTimes";

interface Props {
  privateSerie: PrivateSerieModel;
  purchasing?: boolean;
}

export function PrivateLessonSummary(props: Props) {
  let title = "";

  if (props.purchasing) {
    if (props.privateSerie.offering.frequency === Frequency.Monthly) {
      title = "Pre-scheduled, monthly recurring";
    } else {
      title += "Registering ";

      if (props.privateSerie.isExtending) {
        title = "Extending ";
      }

      title +=
        props.privateSerie.numberOfLessons === 1
          ? `${props.privateSerie.numberOfLessons} lesson`
          : `${props.privateSerie.numberOfLessons} lessons`;
    }
  }

  let summary = (
    <>
      {props.privateSerie.firstLessonStart && (
        <div className="mb-2">
          <div className="font-bold">Earliest date available to start</div>
          {moment(props.privateSerie.firstLessonStart).format(dateFormatMed)}
        </div>
      )}

      {props.privateSerie.availableDays.length > 0 && (
        <div className="mb-2">
          <div className="font-bold">Days of the week available</div>
          {props.privateSerie.availableDays.join(", ")}
        </div>
      )}

      {props.privateSerie.customerInfoRequestResponses.map((r, i) => {
        return (
          <div key={i} className="mb-2">
            <div className="font-bold">{r.question}</div>
            <div>{r.answer}</div>
          </div>
        );
      })}

      {props.privateSerie.studentInfoRequestResponses.map((r, i) => {
        const question = props.privateSerie.offering.studentInfoRequests.find(
          (sir) => sir.id === r.studentInfoRequest?.id
        );
        let response = r.description;
        let description = r.studentInfoRequest?.description;

        if (question && !description) {
          description = question.description;
        }

        if (r.additionalResponse) {
          response += ` • ${r.additionalResponse}`;
        }

        return (
          <div key={i} className="mb-2">
            <div className="font-bold">{description}</div>
            <div>{response}</div>
          </div>
        );
      })}

      {props.privateSerie.offering.frequency === Frequency.Monthly && (
        <ClassTimes classItem={props.privateSerie.offering} />
      )}
    </>
  );

  if (props.privateSerie.isExtending) {
    summary = <div>{props.privateSerie.note}</div>;
  }

  return (
    <>
      {title && (
        <div className="mb-3">
          <strong>{title}</strong>
        </div>
      )}

      {summary && <div>{summary}</div>}
    </>
  );
}
